import { useAppDispatch, useAppState } from '@/store';
import { getCoupons, selectCoupons, selectCouponsError, selectCouponsIsLoading } from '../feature';
import { useEffect } from 'react';

const useGetCoupons = (channelId?: number) => {
  const dispatch = useAppDispatch();
  const coupons = useAppState(selectCoupons);
  const isLoading = useAppState(selectCouponsIsLoading);
  const error = useAppState(selectCouponsError);

  useEffect(() => {
    if (!channelId) return;

    if (!coupons && !isLoading && !error) {
      dispatch(getCoupons({ channelId }));
    }
  }, [coupons, isLoading, error, dispatch, channelId]);

  return { coupons, isLoading, error };
};

export default useGetCoupons;
